// Sidebar
export const SIDEBAR_VISIBILITY_TOGGLE = "SIDEBAR_VISIBILITY_TOGGLE";
export const SIDEBAR_VISIBILITY_SHOW = "SIDEBAR_VISIBILITY_SHOW";
export const SIDEBAR_VISIBILITY_HIDE = "SIDEBAR_VISIBILITY_HIDE";
export const SIDEBAR_STICKY_TOGGLE = "SIDEBAR_STICKY_TOGGLE";
export const SIDEBAR_STICKY_ENABLE = "SIDEBAR_STICKY_ENABLE";
export const SIDEBAR_STICKY_DISABLE = "SIDEBAR_STICKY_DISABLE";

// Layout
export const LAYOUT_BOXED_TOGGLE = "LAYOUT_BOXED_TOGGLE";
export const LAYOUT_BOXED_ENABLE = "LAYOUT_BOXED_ENABLE";
export const LAYOUT_BOXED_DISABLE = "LAYOUT_BOXED_DISABLE";

// Theme
export const THEME_TOGGLE = "THEME_TOGGLE";

// Poinsettia
export const GET_CHART_TITLES = "GET_CHART_TITLES";
export const GET_YEARS = "GET_YEARS";
export const SELECT_CHART = "SELECT_CHART";
export const CREATE_CHART = "CREATE_CHART";
export const ADD_MEASUREMENT = "ADD_MEASUREMENT";
export const ADD_CHEMICAL = "ADD_CHEMICAL";
export const ADD_LEVEL = "ADD_LEVEL";
export const CLEAR_POINSETTIA = "CLEAR_POINSETTIA";
export const EDIT_CHART = "EDIT_CHART";
export const COPY_CHART = "COPY_CHART";
export const DELETE_CHART = "DELETE_CHART";
export const UPDATE_TABLE = "UPDATE_TABLE";
export const SAVE_TABLE = "SAVE_TABLE";
export const CHANGE_DATE = "CHANGE_DATE";
export const POINSETTIA_CLEAN_UP = "POINSETTIA_CLEAN_UP";

// Poinsettia
export const GET_MUM_CHART_TITLES = "GET_MUM_CHART_TITLES";
export const GET_MUM_YEARS = "GET_MUM_YEARS";
export const SELECT_MUM_CHART = "SELECT_MUM_CHART";
export const CREATE_MUM_CHART = "CREATE_MUM_CHART";
export const ADD_MUM_MEASUREMENT = "ADD_MUM_MEASUREMENT";
export const ADD_MUM_CHEMICAL = "ADD_MUM_CHEMICAL";
export const ADD_MUM_LEVEL = "ADD_MUM_LEVEL";
export const CLEAR_MUM = "CLEAR_MUM";
export const EDIT_MUM_CHART = "EDIT_MUM_CHART";
export const COPY_MUM_CHART = "COPY_MUM_CHART";
export const DELETE_MUM_CHART = "DELETE_MUM_CHART";
export const UPDATE_MUM_TABLE = "UPDATE_MUM_TABLE";
export const SAVE_MUM_TABLE = "SAVE_MUM_TABLE";
export const CHANGE_MUM_DATE = "CHANGE_MUM_DATE";
export const MUM_CLEAN_UP = "MUM_CLEAN_UP";

// AUTH
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';

// Machines
export const GET_ITEMS = 'GET_ITEMS';
export const SELECT_ITEM = 'SELECT_ITEM';
export const UPDATE_ITEM_NOTE = 'UPDATE_ITEM_NOTE';
export const SEND_ITEM_NOTE = 'SEND_ITEM_NOTE';
export const EDIT_ITEM_NOTE = 'EDIT_ITEM_NOTE';
export const SAVE_ITEM_ATTRIBUTE = 'SAVE_ITEM_ATTRIBUTE';
export const CREATE_NEW_ITEM = 'CREATE_NEW_ITEM';
export const GET_REPORT = 'GET_REPORT';

// Jobs
export const GET_TASK = 'GET_OPEN_TASK';
export const CREATE_TASK = 'CREATE_TASK';
export const COMPLETE_TASK = 'COMPLETE_TASK';
export const GET_EMPLOYEES = 'GET_EMPLOYEES';

// Productions
export const GET_PRODUCTIONS = 'GET_PRODUCTIONS';
export const SORT_CHART = 'SORT_CHART';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const GET_POTS = 'GET_POTS';
export const POST_INPUTS = 'POST_INPUTS';
export const SET_WAGE = 'SET_WAGE';

// Production Settings
export const GET_POTLIST = "GET_POTLIST";
export const SELECT_PSETTINGS_ITEM = "SELECT_PSETTINGS_ITEM";
export const ADD_NEW_CATEGORY = "ADD_NEW_CATEGORY";
export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const SAVE_POT_CATEGORY = "SAVE_POT_CATEGORY";
export const SAVE_POT_DESCRIPTION = "SAVE_POT_DESCRIPTION";
export const CREATE_NEW_POT = "CREATE_NEW_POT";
